module.exports = __webpack_public_path__ + "img/climate_actions_certificate.e331266.webp";